import React, { useContext, useEffect, useState } from 'react'
import Page from '../../../components/Pages/Page'
import { useParams } from 'react-router-dom'
import { useAPI } from '../../../hooks/useAPI'
import { AuthContext } from '../../../context/AuthContext'
import PatientLogInPage from '../../Patient/PatinetAuth/PatientLogIn/PatientLogInPage'
import Viewer from '../../../components/Viewer/Viewer'

const LiteviewerPage = () => {
	const {userId, token } = useContext(AuthContext)
    const { result_id } = useParams()
    const { APIRequest } = useAPI()
    const [mobile, setMobile] = useState(false)
	const [res, setRes] = useState({})

    // Следим за размером окна
    window.addEventListener('resize', () => {
        setMobile(window.innerWidth < 1100)
    })

    const getData = async (imageId) => {
		await APIRequest({api:`/api/v2/patients/${userId}/viewer/${imageId}`, method: 'GET'})
            .then(res => {
				res.message === 'ок' &&
				  setRes({
					attributes: {
					  ...res.body.data[0].attributes,
					  dob: res.body.data[0]?.attributes.dob,
					  id: res?.body?.data[0]?.id
					},
					history: res.body?.data[0]?.histories.map((item) => ({
					  ...item,
					  _id: item.id,
					  resultDate: item.result_date
					})),
					userId: res.body?.data[0]?.id
				  })
			})
	}

    useEffect(() => {
        setMobile(window.innerWidth < 1100)
		getData(result_id)
    }, [])

    return (
        <>
            <Page name={'patient-qr-result__page'} mobile={true} animation={'fade-in-fwd'} style={{justifyContent: 'flex-start'}}>
                <div style={{marginLeft: 0}}>
					<Viewer {...res} right={0} mode={'reading'} />
                </div>

            </Page>
        </>
    );
}


export const Liteviewer = _ => {
    // Функция проверяет на авторизацию и переводит в соответствующий компонент
    // Это нужно чтобы корректно отображать компоненты, так как роут CheckIn имеется как и для авторизованных пользователей, так не авторизованных.
    const {isAuthenticated} = useContext(AuthContext)
    if (isAuthenticated === true) {
        return <LiteviewerPage/>
    } else {
        return <PatientLogInPage attention={true}/>
    }
}
